import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { Collection } from '../collection.model';

@JsonObject('CollectionsResultsResponse')
export class CollectionsResultsResponse extends ApiResultsResponse<Collection> {

  @JsonProperty('results', [Collection])
  override results: Collection[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
